(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define("rb_wixui.thunderbolt_common-site-members-dialogs", ["lodash", "react"], factory);
	else if(typeof exports === 'object')
		exports["rb_wixui.thunderbolt_common-site-members-dialogs"] = factory(require("lodash"), require("react"));
	else
		root["rb_wixui.thunderbolt_common-site-members-dialogs"] = factory(root["_"], root["React"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE_T9FV__, __WEBPACK_EXTERNAL_MODULE_Xdf___) {
return 